export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Подушка 60x40см с рисунком или фотографией на всей поверхности.</p>
        <p>Подушки сшиты из мокрого шёлка - это ткань премиального качества. По сравнению с атласом или сатеном, мокрый шёлк очень нежный и приятный. На подушках из мокрого шёлка можно смело спать.</p>
        <p>Наполнитель: экологически чистый синтепон.</p>
        <p>Размеры и область печати: 60x40см.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.
        </p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
